import React from 'react';
import styled from 'styled-components';
import { RichH4, P2, RichP2 } from '../Typography';
import { DesktopFooterNavigation } from './DesktopFooterNavigation';
import { UnstyledLink } from '../Link';
import { Image } from '../Image';
import media from '../../utils/media';
import { isFieldValid, isCookieSettingsLinkValid } from '../../utils/validation';
import { getParsedField, getLinkHref } from '../../utils/helpers';
import { renderLinkByType } from './helper';
const Container = styled.footer `
outline: none;
  margin-bottom: 52px;
  ${media.mobile} {
    display: none;
  }

  ${media.tablet} {
    display: none;
  }
`;
const DesktopFooterContainer = styled.div `
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;

  border-bottom: 4px solid ${({ theme }) => theme.trueBlack};
  border-top: 6px solid ${({ theme }) => theme.trueBlack};
  padding-top: 48px;
  padding-bottom: 60px;
  width: 85%;
  max-width: 1440px;
`;
const SocialSectionSubtitle = styled(RichH4) `
  margin-bottom: 20px;
  color: ${({ theme }) => theme.trueBlack};
  text-align: center;
`;
const CopyrightText = styled(RichP2) `
  color: ${({ theme }) => theme.greyDark};
`;
const CopyrightContainer = styled.div `
  margin-bottom: 5px;
`;
const LegalLinksContainer = styled.div `
  display: inline-flex;
`;
const LegalContainer = styled.div `
  text-align: center;
  margin-top: 30px;
`;
const Divider = styled(P2) `
  color: ${({ theme }) => theme.greyDark};
  margin: 0 5px 0 5px;
`;
const divider = { value: '|' };
const SocialMediaContainer = styled.div `
  text-align: center;
  text-align: -webkit-center;
  margin-bottom: 50px;
`;
const IconImage = styled(Image) `
  max-width: 43px;
`;
const ImageContainer = styled.div `
  display: inline-flex;
  &:not(:last-child) {
    margin-right: 40px;
  }
`;
const ConsentLink = styled.a `
  color: ${({ theme }) => theme.trueBlack};
  font-family: ${({ theme }) => theme.fontFamilyBase};
  font-size: 16px;
  line-height: 24px;
  font-weight: normal;
  font-style: normal;
  width: 100%;
  white-space: nowrap;
  display: inline-flex;
  cursor: pointer
  &:hover {
    color: ${({ theme }) => theme.trueBlack};
  }
`;
// function isCookieSettingsLinkValid(field: any) {
//   return !!(field && field.value && field.value.text && field.value.class);
// };
export const DesktopFooter = ({ items }) => {
    if (!items) {
        console.warn('DesktopFooter component requires fields to be provided');
        return null;
    }
    const socialMediaSection = items.find((item) => item.displayName === 'SocialMediaSection');
    const socialMediaFields = socialMediaSection && socialMediaSection.fields && socialMediaSection.fields;
    const subtitle = socialMediaFields && socialMediaFields.subtitle;
    const parsedSubtitle = getParsedField(subtitle);
    const socialMediaIcons = socialMediaFields && socialMediaFields.items;
    const legalSection = items.find((item) => item.displayName === 'LegalSection');
    const legalItems = legalSection && legalSection.fields && legalSection.fields.items;
    const navSection = items.find((item) => item.displayName === 'NavigationSection');
    function renderSocialMediaIcons(socialMediaIcons) {
        return (React.createElement(React.Fragment, null, socialMediaIcons &&
            socialMediaIcons.map(({ fields }, index) => {
                const { logo, url } = fields;
                const { text: ariaLabel } = url.value;
                return (React.createElement(ImageContainer, { key: index },
                    React.createElement(UnstyledLink, { field: url, ariaLabel: ariaLabel },
                        React.createElement(IconImage, { media: logo, width: null, height: null }))));
            })));
    }
    function renderLegalItems(legalItems) {
        return (React.createElement(React.Fragment, null, legalItems &&
            legalItems.map(({ fields }, index) => {
                var _a, _b;
                const { copyRightText, termsLabel, termsUrl, privacyLabel, privacyUrl, cookieSettingsLink } = fields;
                const termsUrlModifyed = getLinkHref(termsUrl);
                const privacyUrlModifyed = getLinkHref(privacyUrl);
                const { text: ariaLabelTerms } = termsUrlModifyed && termsUrlModifyed.value;
                const { text: ariaLabelPrivacy } = privacyUrlModifyed && privacyUrlModifyed.value;
                return (React.createElement(LegalContainer, { key: index },
                    React.createElement(CopyrightContainer, null,
                        React.createElement(CopyrightText, { field: copyRightText })),
                    React.createElement(LegalLinksContainer, null,
                        isFieldValid(termsLabel) && renderLinkByType(termsUrlModifyed, termsLabel, ariaLabelTerms),
                        isFieldValid(termsLabel) && isFieldValid(privacyLabel) && React.createElement(Divider, { field: divider }),
                        isFieldValid(privacyLabel) && renderLinkByType(privacyUrlModifyed, privacyLabel, ariaLabelPrivacy),
                        isFieldValid(privacyLabel) && isCookieSettingsLinkValid(cookieSettingsLink) && React.createElement(Divider, { field: divider }),
                        isCookieSettingsLinkValid(cookieSettingsLink) &&
                            (React.createElement(ConsentLink, { className: (_a = cookieSettingsLink.value) === null || _a === void 0 ? void 0 : _a.class, href: 'javascript:void()' }, (_b = cookieSettingsLink.value) === null || _b === void 0 ? void 0 : _b.text)))));
            })));
    }
    return (React.createElement(Container, null,
        React.createElement(DesktopFooterContainer, null,
            isFieldValid(subtitle) && React.createElement(SocialSectionSubtitle, { field: parsedSubtitle }),
            React.createElement(SocialMediaContainer, null, renderSocialMediaIcons(socialMediaIcons)),
            navSection && React.createElement(DesktopFooterNavigation, { footerItems: items })),
        renderLegalItems(legalItems)));
};
